export enum TemplateLayout {
  Single_Column = 'Single_Column',
  With_Sidebar = 'With_Sidebar',
}
